<template>
  <div>
    <div class="text-sm-right mb-4">
      <v-btn
        v-if="checkAuthorization('kpi_create')"
        class="primary mx-0"
        @click="addKpi"
      >
        <v-icon>mdi-plus</v-icon>Thêm
      </v-btn>
    </div>

    <v-simple-table class="table-layout pa-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th>#</th>
            <th>Tên chỉ tiêu</th>
            <th>Thời gian bắt đầu</th>
            <th>Thời gian kết thúc</th>
            <th>Phòng ban áp dụng</th>
            <th>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(kpi, index) in kpis">
            <tr
              :key="kpi.id"
            >
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ _.get(kpi, 'name') }}
              </td>
              <td>
                {{ _.get(kpi, 'startAt') }}
              </td>
              <td>
                {{ _.get(kpi, 'endAt') }}
              </td>
              <td>
                <template v-for="department in kpi.departments">
                  <span :key="department.id">
                    {{ department.name }}
                    <br>
                  </span>
                </template>
              </td>
              <td>
                <div class="action">
                  <v-tooltip bottom v-if="checkAuthorization('kpi_update')">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2"  @click="editKpi(kpi)" icon small color="primary" dark v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                    </template>
                    <span>Cập nhật thông tin KPI</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2"  @click="showDetailKpi(kpi)" icon small color="info"  v-on="on"><v-icon>mdi-information</v-icon></v-btn>
                    </template>
                    <span>Hiển thị thông tin chi tiêt KPI</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('kpi_delete')">
                    <template v-slot:activator="{ on }">
                      <v-btn @click="delelteKpi(kpi)" icon small color="default"  v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Xóa KPI</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <kpi-form-modal :kpi="selectedKpi" />
  </div>
</template>
<script>
  import KpiFormModal from './KpiFormModal.vue'
  import * as moment from 'moment'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  const KpiRepository = RepositoryFactory.get('kpi')
  export default {
    components: { KpiFormModal },
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      kpis: {
        type: Array,
        default: () => {},
      },
    },
    data () {
      return {
        selectedKpi: {},
        department: [],
        isColor: false
      }
    },
    created () {
      this.isShowEdit()
    },
    methods: {
      isShowEdit(kpi) {
        const currentDate = moment().format('YYYY-MM-DD')
        if (_.get(kpi, 'startAt') && _.get(kpi, 'endAt') < currentDate){
          return true
        }
        return false
      },
      addKpi () {
        this.selectedKpi = {}
        Bus.$emit('show-kpi-form-modal', this.selectedKpi)
      },
      editKpi (kpi) {
        this.selectedKpi = kpi
        Bus.$emit('show-kpi-form-modal', this.selectedKpi)
      },
      showDetailKpi (kpi) {
        this.$router.push({
          name: 'KPIDetail',
          params: {
            id: _.get(kpi, 'id', 0),
          },
        })
      },
      async delelteKpi (kpi) {
        this.$swal({
          title: 'Xóa KPI',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const respond = await KpiRepository.delete(kpi.id)
            // loader.hide()
            this.appLoadingData(false)
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Đã xóa thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('kpi-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
    },
  }
</script>
